import { get } from 'lodash-es'
import { AxiosResponse } from 'axios'
import axios from 'src/axios'
import { FileMimeType } from './enums'
import * as _ from 'lodash-es'
export const FileMimeTypeExtension = {
  'image/bmp': 'dib',
  'application/msword': 'doc',
  'image/gif': 'gif',
  'image/webp': 'webp',
  'image/jpeg': 'jpg',
  'text/plain': 'txt',
  'image/x-portable-bitmap': 'pbm',
  'image/pict': 'pict',
  'application/pdf': 'pdf',
  'image/png': 'png',
  'application/vnd.ms-powerpoint': 'pps',
  'image/svg+xml': 'svgz',
  'image/tiff': 'tiff',
  'application/zip': 'zip',
  'image/heic': 'heic',
  'image/heif': 'heif', //TODO Iphone
}

export const ImageFileMimeType = [
  FileMimeType.JPEG,
  FileMimeType.TIFF,
  FileMimeType.PNG,
  FileMimeType.WEBP,
  FileMimeType.BMP,
  FileMimeType.SVG,
  FileMimeType.TIFF,
  // FileMimeType.HEIC,
  // FileMimeType.HEIF,
]

export const ImageFileExtension = [
  ...ImageFileMimeType.map((mimeType) => FileMimeTypeExtension[mimeType]),
  'jpeg', //TODO Force adding jpeg
]

export const isFileExtensionAllowed = (
  filename: string,
  allowedExtensions: string[]
): boolean => {
  return _.some(allowedExtensions, (extension) => filename.endsWith(extension))
}

export const downloadBlobFile = (response: AxiosResponse) => {
  // Axios types `headers[k]` as `AxiosHeaderValue | undefined`
  // (`string | string[] | number | boolean | null | undefined`). lodash
  // `get` requires a `PropertyPath` here, so narrow both header reads to
  // strings before using them as a path / regex input.
  const rawContentType = get(response.headers, 'content-type')
  const contentType =
    typeof rawContentType === 'string' ? rawContentType : ''
  const rawContentDisposition = get(response.headers, 'content-disposition')
  const contentDisposition =
    typeof rawContentDisposition === 'string' ? rawContentDisposition : ''
  const regExpFilename = /filename="(?<filename>.*)"/
  const filename: string | null =
    regExpFilename.exec(contentDisposition)?.groups?.filename ??
    `${Math.random().toString(36).slice(2)}.${get(
      FileMimeTypeExtension,
      contentType,
      'txt'
    )}`
  const data = URL.createObjectURL(response.data)
  const link = document.createElement('a')
  link.href = data
  link.download = filename
  document.body.appendChild(link)
  link.dispatchEvent(
    new MouseEvent('click', {
      bubbles: true,
      cancelable: true,
      view: window,
    })
  )
  setTimeout(() => {
    // For Firefox it is necessary to delay revoking the ObjectURL
    URL.revokeObjectURL(data)
    link.remove()
  }, 100)
}

export const getFileBase64 = (url: string): Promise<string> => {
  return new Promise((resolve, reject) => {
    return axios
      .get(url, {
        responseType: 'blob',
      })
      .then((response) => {
        resolve(URL.createObjectURL(response.data))
      })
      .catch((response) => reject(response))
  })
}
